import React, { useState } from "react";
import {
  isDocDisabled,
  isDocReadyToSign,
  getDocReadyHint,
} from "../../helpers/docPermissions";
import { NotReadyToSignModal } from "../Popup/ConfirmModal";
import { CancelDocPopup } from "../Popup/CancelDocPopup";
import {
  ListForSign,
  BarMobile,
  BarDevice,
} from "../../styles/Docs/DocsToolbar.styled";
import { Btn } from "../../styles/Button.styled";
import MediaQuery from "react-responsive";
import { DiiaIcon } from "../../../public/icons";
import { useAppSelector } from "../../hooks";
import { IDoc } from "../../interfaces/document";

interface DocsToolbarDeviceProps {
  doc?: IDoc;
  signMethods?: Record<string, any>;
  selectedDocs?: string[];
  isAbleToCancel?: boolean;
  onOpenAttrPopup?: (hint?: string) => void;
  showDetails?: boolean;
  sign?: any;
  hideDownloadFilesBtn?: boolean;
  isStamp?: boolean;
}

export default function DocsToolbarDevice(props: DocsToolbarDeviceProps) {
  const disabled = props.doc && isDocDisabled(props.doc);
  const isDiiaEnabled = process.env.DIIA_ENABLED === "true";
  const [invalidDocs, setInvalidDocs] = useState<string[]>([]);

  const docsList = useAppSelector((state) => (state as any).docs?.list ?? []);
  const [showCancelPopup, setShowCancelPopup] = useState(false);

  const getSignButtonTitle = (): string => {
    const hasStamp = props.doc?.signatures?.some((el) => el.stamp);
    if (props.signMethods?.stamp && !hasStamp) return "Поставити печатку";
    return "Підписати КЕП";
  };
  console.log("DocsToolbarDevice", props.doc, props.signMethods);

  const withValidation = (
    handler: ((...args: any[]) => void) | null | undefined,
  ) => {
    if (!handler) return undefined;
    return (...args: any[]) => {
      if (props.doc) {
        if (!isDocReadyToSign(props.doc)) {
          props.onOpenAttrPopup?.(getDocReadyHint(props.doc));
          return;
        }
        handler(...args);
        return;
      }

      if (props.selectedDocs?.length) {
        const invalid = docsList.filter(
          (doc: any) =>
            props.selectedDocs?.includes(doc.id) && !isDocReadyToSign(doc),
        );
        if (invalid.length > 0) {
          setInvalidDocs(invalid.map((d: any) => d.title || d.id));
          return;
        }
      }

      handler(...args);
    };
  };

  return (
    <>
      {invalidDocs.length > 0 && (
        <NotReadyToSignModal
          docs={invalidDocs}
          onClose={() => setInvalidDocs([])}
        />
      )}
      {showCancelPopup && props.doc && (
        <CancelDocPopup
          docId={props.doc.id}
          onClose={() => setShowCancelPopup(false)}
        />
      )}

      <MediaQuery maxWidth={1239}>
        {!props.doc?.signatures?.length &&
        Object.keys(props.signMethods ?? {}).length > 0 ? (
          <BarMobile>
            <ListForSign
              $allBtn={Object.keys(props.signMethods ?? {}).length === 3}
            >
              {props.signMethods?.diia && isDiiaEnabled && (
                <Btn
                  $background="var(--black)"
                  type="button"
                  onClick={withValidation(props.signMethods.diia)}
                  disabled={disabled}
                  $width="auto"
                  $widthMobile="auto"
                  $fontS="12px"
                  style={{ gap: "8px", flex: 1 }}
                >
                  <DiiaIcon
                    color={disabled ? "var(--disabled-btn-bg)" : "black"}
                  />
                  <div>Підпис</div>
                </Btn>
              )}
              {props.signMethods?.file && (
                <Btn
                  $background="var(--blue)"
                  type="button"
                  onClick={withValidation(props.signMethods.file)}
                  disabled={disabled}
                  $width="100%"
                  $fontS="12px"
                  style={{ flex: 1 }}
                >
                  КЕП
                </Btn>
              )}
              {props.signMethods?.stamp && (
                <Btn
                  $background="var(--blue)"
                  type="button"
                  onClick={withValidation(props.signMethods.stamp)}
                  disabled={disabled}
                  $width="100%"
                  $fontS="12px"
                  style={{ flex: 1 }}
                >
                  Печатка
                </Btn>
              )}

              {props.signMethods?.gryada && (
                <Btn
                  $background="var(--orange)"
                  type="button"
                  onClick={withValidation(props.signMethods.gryada)}
                  disabled={disabled}
                  $width="100%"
                  $fontS="12px"
                  style={{ flex: 1 }}
                >
                  Гряда
                </Btn>
              )}
            </ListForSign>
            {props.isAbleToCancel && (
              <Btn
                $background="var(--red)"
                type="button"
                onClick={() => setShowCancelPopup(true)}
                disabled={disabled}
                $width="100%"
                $fontS="12px"
                style={{ flex: 1 }}
              >
                Скасувати
              </Btn>
            )}
          </BarMobile>
        ) : null}
      </MediaQuery>

      <MediaQuery minWidth={1240}>
        {Object.keys(props.signMethods ?? {}).length > 0 ? (
          <BarDevice id="bar">
            <>
              {props.signMethods?.diia && isDiiaEnabled && (
                <Btn
                  $background="var(--black)"
                  onClick={withValidation(props.signMethods.diia)}
                  disabled={disabled}
                  $fontS="14px"
                  $width="100%"
                  style={{ gap: "8px" }}
                >
                  <DiiaIcon
                    color={disabled ? "var(--disabled-btn-bg)" : "black"}
                  />
                  <div>Підпис</div>
                </Btn>
              )}
              {props.signMethods?.file && (
                <Btn
                  $background="var(--blue)"
                  onClick={withValidation(props.signMethods.file)}
                  disabled={disabled}
                  $width="100%"
                  $fontS="14px"
                >
                  {getSignButtonTitle()}
                </Btn>
              )}
      

              {props.signMethods?.gryada && (
                <Btn
                  $background="var(--orange)"
                  $fontS="14px"
                  onClick={withValidation(props.signMethods.gryada)}
                  disabled={disabled}
                  $width="100%"
                >
                  Підпис Гряда
                </Btn>
              )}
            </>
          </BarDevice>
        ) : null}
        {props.isAbleToCancel && (
          <div style={{ marginTop: 10 }}>
            <Btn
              $background="var(--vivid-pink)"
              type="button"
              onClick={() => setShowCancelPopup(true)}
              disabled={disabled}
              $width="100%"
              $fontS="14px"
            >
              Скасувати
            </Btn>
          </div>
        )}
      </MediaQuery>
    </>
  );
}
